import { DAIMI_AU_INTRO, DAIMI_AU_SLUG } from '@/content/daimiAutomotive'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The seventh report with a designed page of its own, and the third whose
  // own copy was supplied rather than paraphrased — asked for on 2026-08-27
  // (*"automotive focus report"*) with a full-page screenshot of the live
  // page, the cover at 2560px, Figure 1 and the report mockup. See
  // `content/daimiAutomotive.ts` and `pages/DaimiAutomotive.tsx`.
  ...focus(
    DAIMI_AU_SLUG,
    'Automotive',
    'daimi-report-2026-automotive-cover',
    '018f829c-6339-4292-b19c-e88738f3f1d3-digitopia-daimi-2026-report-automotive.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference screenshot and
  // held on the page that says them — so the search result and the page cannot
  // drift apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_AU_INTRO.body,
  layout: 'automotive-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section
  // on its page, and `daimiAutomotiveChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 5
